import { UrlConstants } from "../url.constants";
export class ApiEhActionTypeSurveyConstants {
    static URL = UrlConstants.API_V2 + "EhActionTypeSurvey";
    static FUNCTION_DELETE = "Delete";
    static FUNCTION_PATCH = "Patch";
    static FUNCTION_GET = "GET";
}
